import { Box } from '@zoopla-eng/zds/box';
import ListingCard from '@zoopla/listing-card';
import { Skeleton } from '@zoopla-eng/zds/skeleton';
import {
    borderBoxStyle,
    customGridStyle,
    wave1Style,
    wave2Style,
    wave3Style,
    wave4Style,
    wave5Style,
    wave6Style,
    wave7Style,
    wave8Style
} from './ListingsSkeleton.styles.css';

export const ListingsSkeleton = () => (
    <Box display="flex" flexDirection="column" rowGap="S400">
        {[...Array(25).keys()].map((index) => (
            <ListingCard.Layout key={`listing-skeleton-${index}`}>
                <ListingCard.LayoutMedia>
                    <div className={wave1Style}>
                        <Skeleton.Wave />
                    </div>
                </ListingCard.LayoutMedia>
                <ListingCard.LayoutContent>
                    <div className={borderBoxStyle}>
                        <div className={customGridStyle}>
                            <div className={wave2Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave3Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave3Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave3Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave3Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave4Style}>
                                <Skeleton.Wave curved />
                            </div>
                            <div className={wave5Style}>
                                <Skeleton.Wave curved />
                            </div>
                        </div>
                    </div>
                </ListingCard.LayoutContent>
                <ListingCard.LayoutFooterLeft>
                    <Box display="flex">
                        <div className={wave6Style}>
                            <Skeleton.Wave
                            // css={{ borderRadius: '8px' }}
                            />
                        </div>
                    </Box>
                </ListingCard.LayoutFooterLeft>
                <ListingCard.LayoutFooterRight>
                    <Box display="flex" columnGap="S400">
                        <div className={wave7Style}>
                            <Skeleton.Wave curved />
                        </div>
                        <div className={wave8Style}>
                            <Skeleton.Wave curved />
                        </div>
                        <div className={wave8Style}>
                            <Skeleton.Wave curved />
                        </div>
                    </Box>
                </ListingCard.LayoutFooterRight>
            </ListingCard.Layout>
        ))}
    </Box>
);
